import { atom } from 'recoil';
import { Dashboard, DashboardQuery } from '../types/files';
import { DefaultQueryTemplate } from '../contexts/DashboardContext';

const dashboardState = atom<Dashboard | null>({
  key: 'dashboard/dashboard',
  default: null,
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['dashboard/dashboard', newValue]);
    });
  }],
});

const dashboardQueriesState = atom<DashboardQuery[]>({
  key: 'dashboard/dashboardQueries',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['dashboard/dashboardQueries', newValue]);
    });
  }],
});

const defaultQueryTemplateValuesState = atom<DefaultQueryTemplate[]>({
  key: 'dashboard/defaultQueryTemplateValues',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['dashboard/defaultQueryTemplateValues', newValue]);
    });
  }],
});

const isPublicViewState = atom<boolean>({
  key: 'dashboard/isPublicView',
  default: false,
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['dashboard/isPublicView', newValue]);
    });
  }],
});

const isSharedState = atom<boolean>({
  key: 'dashboard/isShared',
  default: false,
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['dashboard/isShared', newValue]);
    });
  }],
});

export {
  dashboardState,
  dashboardQueriesState,
  defaultQueryTemplateValuesState,
  isPublicViewState,
  isSharedState,
};
